<div class="grade-container" [id]="'card-'+grade.id" [class.rtl]="currLang == 'ar'" [class.has-error]="cardError"
    [class.has-warning]="!cardError && cardWarning">

    <!-- can't edit during dismissal time -->
    <div *ngIf="dismissalStartedFlag" class="dismissal-alert">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8.5V13M12 16.5H12.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{'grades-classes.grade-card.dismissal-started' | translate}} {{formated_closing_time}}</span>
    </div>

    <!-- header : grade name , what is missing , actions -->
    <div class="card-head">
        <div class="identity">
            <span class="grade-badge" [class.error]="cardError">{{grade.name}}</span>
            <!-- nothing is claimed to be correct , only gaps are called out -->
            <span class="status-pill error" *ngIf="cardError">
                <span class="dot"></span>
                {{'grades-classes.grade-card.missing-data' | translate}}
            </span>
            <span class="status-pill warning" *ngIf="!cardError && cardWarning">
                <span class="dot"></span>
                {{'grades-classes.grade-card.missing-optional' | translate}}
            </span>
        </div>
        <div class="actions">
            <span class="icon-btn" (click)="editGrade(grade.id,gradeIndex,false)"
                matTooltip="{{'grades-classes.grade-card.edit' | translate}}">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18.4" viewBox="0 0 16 14">
                    <g id="Group_409" data-name="Group 409">
                        <path id="Path_1390" data-name="Path 1390"
                            d="M21.117,114.3H6.257a.535.535,0,0,0-.557.5.544.544,0,0,0,.557.5H21.131a.535.535,0,0,0,.557-.5A.548.548,0,0,0,21.117,114.3Z"
                            transform="translate(-5.688 -101.308)" fill="currentColor" />
                        <path id="Path_1391" data-name="Path 1391"
                            d="M5.612,15.642,5.6,18.04a.521.521,0,0,0,.148.369.492.492,0,0,0,.357.148l2.385-.012a.492.492,0,0,0,.357-.148l8.238-8.238a.52.52,0,0,0,0-.725L14.723,7.048a.52.52,0,0,0-.725,0L12.35,8.707,5.76,15.285A.548.548,0,0,0,5.612,15.642ZM14.367,8.13l1.66,1.66-.934.934-1.66-1.66.934-.934ZM6.633,15.863l6.074-6.074,1.66,1.66L8.293,17.511l-1.672.012.012-1.66Z"
                            transform="translate(-5.6 -6.9)" fill="currentColor" />
                    </g>
                </svg>
            </span>
            <span class="icon-btn danger" *ngIf="students.length === 0" (click)="deleteGrade()"
                matTooltip="{{'grades-classes.grade-card.delete' | translate}}">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="21.5" viewBox="0 0 13.1 16.129">
                    <g id="bin_1_" data-name="bin (1)" transform="translate(0.003 0.002)">
                        <path
                            d="M222.776,154.7a.378.378,0,0,0-.378.378v7.139a.378.378,0,1,0,.755,0v-7.139A.378.378,0,0,0,222.776,154.7Zm0,0"
                            transform="translate(-214 -148.861)" fill="currentColor" />
                        <path
                            d="M104.776,154.7a.378.378,0,0,0-.378.378v7.139a.378.378,0,1,0,.755,0v-7.139A.378.378,0,0,0,104.776,154.7Zm0,0"
                            transform="translate(-100.458 -148.861)" fill="currentColor" />
                        <path
                            d="M1.07,4.8v9.307a2.084,2.084,0,0,0,.554,1.437,1.86,1.86,0,0,0,1.35.584H10.12a1.86,1.86,0,0,0,1.35-.584,2.084,2.084,0,0,0,.554-1.437V4.8a1.443,1.443,0,0,0-.37-2.838H9.72V1.491A1.484,1.484,0,0,0,8.224,0H4.87a1.484,1.484,0,0,0-1.5,1.492v.472H1.44A1.443,1.443,0,0,0,1.07,4.8ZM10.12,15.372H2.973a1.2,1.2,0,0,1-1.148-1.265V4.834h9.443v9.273a1.2,1.2,0,0,1-1.148,1.265ZM4.129,1.491A.728.728,0,0,1,4.87.754H8.224a.728.728,0,0,1,.74.737v.472H4.129ZM1.44,2.718H11.654a.68.68,0,1,1,0,1.36H1.44a.68.68,0,0,1,0-1.36Zm0,0"
                            transform="translate(0 0)" fill="currentColor" />
                        <path
                            d="M163.776,154.7a.378.378,0,0,0-.378.378v7.139a.378.378,0,1,0,.755,0v-7.139A.378.378,0,0,0,163.776,154.7Zm0,0"
                            transform="translate(-157.229 -148.861)" fill="currentColor" />
                    </g>
                </svg>
            </span>
            <span class="icon-btn dimmed" *ngIf="students.length > 0"
                matTooltip="{{'grades-classes.grade-card.delete' | translate}}">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="21.5" viewBox="0 0 13.1 16.129">
                    <g id="bin_2_" data-name="bin (2)" transform="translate(0.003 0.002)">
                        <path
                            d="M222.776,154.7a.378.378,0,0,0-.378.378v7.139a.378.378,0,1,0,.755,0v-7.139A.378.378,0,0,0,222.776,154.7Zm0,0"
                            transform="translate(-214 -148.861)" fill="currentColor" />
                        <path
                            d="M104.776,154.7a.378.378,0,0,0-.378.378v7.139a.378.378,0,1,0,.755,0v-7.139A.378.378,0,0,0,104.776,154.7Zm0,0"
                            transform="translate(-100.458 -148.861)" fill="currentColor" />
                        <path
                            d="M1.07,4.8v9.307a2.084,2.084,0,0,0,.554,1.437,1.86,1.86,0,0,0,1.35.584H10.12a1.86,1.86,0,0,0,1.35-.584,2.084,2.084,0,0,0,.554-1.437V4.8a1.443,1.443,0,0,0-.37-2.838H9.72V1.491A1.484,1.484,0,0,0,8.224,0H4.87a1.484,1.484,0,0,0-1.5,1.492v.472H1.44A1.443,1.443,0,0,0,1.07,4.8ZM10.12,15.372H2.973a1.2,1.2,0,0,1-1.148-1.265V4.834h9.443v9.273a1.2,1.2,0,0,1-1.148,1.265ZM4.129,1.491A.728.728,0,0,1,4.87.754H8.224a.728.728,0,0,1,.74.737v.472H4.129ZM1.44,2.718H11.654a.68.68,0,1,1,0,1.36H1.44a.68.68,0,0,1,0-1.36Zm0,0"
                            transform="translate(0 0)" fill="currentColor" />
                        <path
                            d="M163.776,154.7a.378.378,0,0,0-.378.378v7.139a.378.378,0,1,0,.755,0v-7.139A.378.378,0,0,0,163.776,154.7Zm0,0"
                            transform="translate(-157.229 -148.861)" fill="currentColor" />
                    </g>
                </svg>
            </span>
        </div>
    </div>

    <!-- what exactly is missing , a supervisor is not as urgent as the rest -->
    <div class="missing-chips" *ngIf="issues.keys.length > 0">
        <span class="missing-label" [class.warning-only]="!cardError">
            {{'grades-classes.grade-card.missing' | translate}}
        </span>
        <span class="chip" *ngFor="let item of issues.criticalKeys">
            {{('grades-classes.grade-card.missing-items.' + item) | translate}}
        </span>
        <span class="chip warning" *ngFor="let item of issues.warningKeys">
            {{('grades-classes.grade-card.missing-items.' + item) | translate}}
        </span>
    </div>

    <!-- classes first , they are what the grade is made of -->
    <div class="section classes-section">
        <div class="section-head">
            <label class="section-label">
                {{'grades-classes.grade-card.classes' | translate}}
                <span class="count">{{classes.length | arabicNumber: currLang}}</span>
            </label>
            <button type="button" class="reorder-btn" *ngIf="classes.length > 1"
                (click)="openReorderClassesModal(classes)">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 20V4M7 20L4 17M7 20L10 17M17 4V20M17 4L14 7M17 4L20 7" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{{'grades-classes.grade-card.reorder-classes-text' | translate}}</span>
            </button>
        </div>

        <div class="classes-table">
            <div class="table-row head">
                <div class="col class-col">{{'grades-classes.grade-card.classes' | translate}}</div>
                <div class="col teacher-col">{{'grades-classes.grade-card.assigned-teachers' | translate}}</div>
                <div class="col students-col">{{'grades-classes.grade-card.students' | translate}}</div>
                <div class="col action-col"></div>
            </div>

            <!-- every class is listed , nothing is hidden behind a toggle -->
            <div class="table-row" *ngFor="let oneClass of classes">
                <div class="col class-col">
                    <span class="class-name">{{oneClass.name}}</span>
                </div>
                <div class="col teacher-col">
                    <span (click)="addStaff()" *ngIf="oneClass.teachers.length === 0" class="unassigned link">
                        {{'grades-classes.grade-card.unassigned' | translate}}
                    </span>
                    <!-- named chips read better than "multiple users" , the tail rolls up -->
                    <div class="chips" *ngIf="oneClass.teachers.length > 0">
                        <span class="chip person" *ngFor="let teacher of oneClass.teachers | slice:0:chipsLimit"
                            (click)="openTeacher(teacher)" [matTooltip]="teacher.name">
                            {{teacher.name}}
                        </span>
                        <span class="chip more" *ngIf="oneClass.teachers.length > chipsLimit" triggers="manual"
                            #teachersTip="ngbTooltip" (click)="teachersTip.open()"
                            placement="bottom-start top-start auto" container="body"
                            tooltipClass="my-custom-grades-class" [ngbTooltip]="teachersTemplate">
                            {{'grades-classes.grade-card.more-count' | translate:{ count:
                            ((oneClass.teachers.length - chipsLimit) | arabicNumber: currLang) } }}
                        </span>
                    </div>
                    <ng-template #teachersTemplate>
                        <div id="info-container">
                            <div class="teacher" (click)="openTeacher(teacher)"
                                *ngFor="let teacher of oneClass.teachers | slice:chipsLimit">{{teacher.name}}</div>
                        </div>
                    </ng-template>
                </div>
                <div class="col students-col">
                    <span class="students-count" [class.empty]="(oneClass?.students?.length || 0) === 0">
                        {{oneClass?.students?.length || 0 | arabicNumber: currLang}}
                    </span>
                </div>
                <div class="col action-col">
                    <button class="manage-btn" (click)="openClassListing(oneClass)">
                        {{'grades-classes.grade-card.manage-class' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- gate / supervisors / flow -->
    <div class="info-grid">
        <div class="info-block">
            <label>{{'grades-classes.grade-card.assigned-gate' | translate}}</label>
            <div class="value">
                <span class="unassigned" *ngIf="gates.length === 0">
                    {{'grades-classes.grade-card.unassigned' | translate}}
                </span>
                <span class="tag" *ngFor="let gate of gates">{{gate.name}}</span>
            </div>
        </div>

        <div class="info-block">
            <label>{{'grades-classes.grade-card.assigned-supervisors' | translate}}</label>
            <div class="value">
                <!-- a missing supervisor still lets dismissal run , so it is amber -->
                <span class="unassigned warning link" *ngIf="supervisors.length === 0" (click)="addStaff()">
                    {{'grades-classes.grade-card.unassigned' | translate}}
                </span>
                <div class="chips" *ngIf="supervisors.length > 0">
                    <span class="chip person" *ngFor="let supervisor of supervisors | slice:0:chipsLimit"
                        (click)="openSupervisor(supervisor)" [matTooltip]="supervisor.name">
                        {{supervisor.name}}
                    </span>
                    <span class="chip more" *ngIf="supervisors.length > chipsLimit" triggers="manual"
                        #supervisorsTip="ngbTooltip" (click)="supervisorsTip.open()"
                        placement="bottom-start top-start auto" container="body" tooltipClass="my-custom-grades-class"
                        [ngbTooltip]="supervisorsTemplate">
                        {{'grades-classes.grade-card.more-count' | translate:{ count:
                        ((supervisors.length - chipsLimit) | arabicNumber: currLang) } }}
                    </span>
                </div>
                <ng-template #supervisorsTemplate>
                    <div id="info-container">
                        <div class="supervisor" (click)="openSupervisor(supervisor)"
                            *ngFor="let supervisor of supervisors | slice:chipsLimit">{{supervisor.name}}</div>
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- assigned dismissal flow , order matters -->
        <div class="info-block flow-block">
            <label>{{'grades-classes.grade-card.assigned-flow' | translate}}</label>
            <div class="value">
                <ng-container *ngIf="flowSteps.length === 0">
                    <span class="unassigned">{{'grades-classes.grade-card.unassigned' | translate}}</span>
                    <button type="button" class="fix-btn" (click)="goToDismissalFlow()">
                        {{'grades-classes.grade-card.fix' | translate}}
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                            [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
                            <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" stroke-width="2.2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </ng-container>
                <div class="flow-order-container" *ngIf="flowSteps.length > 0">
                    <div class="flow-order" *ngFor="let stage of flowSteps ; let last = last">
                        <div class="flow-name">{{flowStageKey(stage) | translate}}</div>
                        <div class="flow-arrow" *ngIf="!last"
                            [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12"
                                fill="none">
                                <path
                                    d="M6.13228 6.04575L1.29774 10.7327C1.22085 10.799 1.12077 10.8342 1.01796 10.8313C0.915146 10.8284 0.81738 10.7875 0.744649 10.717C0.671918 10.6464 0.629719 10.5517 0.626692 10.452C0.623666 10.3523 0.66004 10.2553 0.728367 10.1807L5.27822 5.76975L0.727338 1.35874C0.659011 1.28421 0.622636 1.18718 0.625663 1.0875C0.62869 0.987828 0.670889 0.893041 0.74362 0.822529C0.816351 0.752018 0.914117 0.711111 1.01693 0.708177C1.11974 0.705243 1.21982 0.740503 1.29671 0.806745L6.13228 5.49175C6.1699 5.52807 6.19974 5.57124 6.2201 5.61878C6.24046 5.66631 6.25095 5.71727 6.25095 5.76875C6.25095 5.82022 6.24046 5.87118 6.2201 5.91872C6.19974 5.96625 6.1699 6.00942 6.13228 6.04575V6.04575Z"
                                    stroke="#98A2B3" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12"
                                fill="none">
                                <path
                                    d="M6.13228 6.04575L1.29774 10.7327C1.22085 10.799 1.12077 10.8342 1.01796 10.8313C0.915146 10.8284 0.81738 10.7875 0.744649 10.717C0.671918 10.6464 0.629719 10.5517 0.626692 10.452C0.623666 10.3523 0.66004 10.2553 0.728367 10.1807L5.27822 5.76975L0.727338 1.35874C0.659011 1.28421 0.622636 1.18718 0.625663 1.0875C0.62869 0.987828 0.670889 0.893041 0.74362 0.822529C0.816351 0.752018 0.914117 0.711111 1.01693 0.708177C1.11974 0.705243 1.21982 0.740503 1.29671 0.806745L6.13228 5.49175C6.1699 5.52807 6.19974 5.57124 6.2201 5.61878C6.24046 5.66631 6.25095 5.71727 6.25095 5.76875C6.25095 5.82022 6.24046 5.87118 6.2201 5.91872C6.19974 5.96625 6.1699 6.00942 6.13228 6.04575V6.04575Z"
                                    stroke="#98A2B3" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
